import style from './style.module.scss';

const PictoTrophee = ({ src, alt = 'Pictogramme trophée' }) => {
    return src ? (
        <img className={style.pictoTrophee} src={src} alt={alt}></img>
    ) : null; // <span className={style.pictoTrophee} />
};

export default PictoTrophee;
